import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e80a7dce")

_pushScopeId("data-v-e80a7dce")
const _hoisted_1 = {
  key: 0,
  class: "buoy-wrap",
  style: {"display":"none"}
}
const _hoisted_2 = { class: "buoy-main fill df-middle df-center" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Icon = _resolveComponent("Icon")
  const _component_Pic = _resolveComponent("Pic")

  return (_ctx.showBuoy)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("div", _hoisted_2, [
          _createVNode("div", {
            class: "close df-middle df-center",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeClick && _ctx.closeClick(...args)))
          }, [
            _createVNode(_component_Icon, {
              name: "close",
              class: "close-icon"
            })
          ]),
          _createVNode(_component_Pic, {
            src: _ctx.buoyType===4?'home/QuizBuoy':'home/GachaBuoy',
            width: "72",
            height: "72",
            onClick: _ctx.linkClick
          }, null, 8, ["src", "onClick"])
        ])
      ]))
    : _createCommentVNode("", true)
})